"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationKpi',
  data: function data() {
    return {
      tab: 'kpi',
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        status: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    planText: function planText(value) {
      return {
        draft: '草稿',
        enabled: '已启用',
        completed: '已完成',
        cancelled: '已取消'
      }[value] || value;
    },
    rewardText: function rewardText(value) {
      return {
        pending: '待审',
        effective: '已生效',
        appealed: '申诉中',
        revoked: '已撤销',
        settled: '已核销'
      }[value] || value;
    },
    actionText: function actionText(value) {
      return {
        enable: '启用',
        recalc: '重算',
        confirm: '确认',
        adjust: '调整',
        complete: '完成',
        cancel: '取消',
        approve: '通过',
        settle: '核销',
        appeal: '申诉',
        revoke: '撤销'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      var api = this.tab === 'kpi' ? _decoration.decorationKpiListApi : _decoration.decorationRewardListApi;
      api(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.searchForm.page = value;
      this.loadCurrent();
    },
    openKpi: function openKpi() {
      var _this2 = this;
      var end = new Date();
      var start = new Date(end.getFullYear(), end.getMonth(), 1);
      var fmt = function fmt(d) {
        return "".concat(d.getFullYear(), "-").concat(String(d.getMonth() + 1).padStart(2, '0'), "-").concat(String(d.getDate()).padStart(2, '0'));
      };
      this.$prompt('计划名称', '制订KPI').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationKpiSaveApi)({
          name: value || '本月获客KPI',
          metricCode: 'lead',
          targetValue: 2,
          periodType: 'month',
          periodStart: fmt(start),
          periodEnd: fmt(end),
          targetType: 'company'
        }).then(function () {
          _this2.$message.success('KPI已制订');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    openReward: function openReward() {
      var _this3 = this;
      this.$prompt('奖罚说明', '登记奖励').then(function (_ref2) {
        var value = _ref2.value;
        (0, _decoration.decorationRewardSaveApi)({
          recordType: 'reward',
          reasonCode: 'kpi_bonus',
          reasonText: value || '后台登记奖励',
          amount: 100
        }).then(function () {
          _this3.$message.success('奖罚已登记');
          _this3.loadCurrent();
        });
      }).catch(function () {});
    },
    runKpi: function runKpi(row, action) {
      var _this4 = this;
      var payload = {
        action: action
      };
      var exec = function exec(actual) {
        if (actual !== undefined) payload.actualValue = Number(actual);
        (0, _decoration.decorationKpiActionApi)(row.plan.id, payload).then(function () {
          _this4.$message.success('KPI已更新');
          _this4.loadCurrent();
        });
      };
      if (['recalc', 'confirm', 'adjust'].includes(action)) {
        this.$prompt('完成值', this.actionText(action)).then(function (_ref3) {
          var value = _ref3.value;
          return exec(value);
        }).catch(function () {});
      } else {
        this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
          return exec();
        }).catch(function () {});
      }
    },
    runReward: function runReward(row, action) {
      var _this5 = this;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationRewardActionApi)(row.record.id, {
          action: action
        }).then(function () {
          _this5.$message.success('奖罚已更新');
          _this5.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};